import React from 'react';
import styles from './TagsForm.module.scss';
import { ReportTag } from '../../../../../Models';
import { TagsField } from '../../FieldInput/TagsField/TagsField';

export interface TagsFormProps {
  value: ReportTag[];
  onChange: (tags: ReportTag[]) => void;
}

export const TagsForm = ({
  value,
  onChange
}: TagsFormProps): React.ReactElement<TagsFormProps> => {
  return (
    <div className={styles.tagsForm}>
      <div className={styles.title}>
        <h3>Contact Tags</h3>
      </div>

      <TagsField
        label="Tags"
        value={value}
        onChange={(v) => onChange(v as ReportTag[])}
      />
    </div>
  );
};
